import { render, staticRenderFns } from "./background-image-overlay-opacity.vue?vue&type=template&id=510a10ca&"
import script from "./background-image-overlay-opacity.vue?vue&type=script&lang=js&"
export * from "./background-image-overlay-opacity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports